import { Component, OnInit } from '@angular/core';
import { GetPartnerIDService } from 'src/app/services/donation/getPartnerID/get-partner-id.service';
import { SearchEventService } from '../../../services/search/searchEvent/search-event.service';
import Swal from 'sweetalert2'
import { UpdateEventStatusService } from 'src/app/services/events/updateEventStatus/update-event-status.service';

declare var $: any
@Component({
  selector: 'app-event-registration',
  templateUrl: './event-registration.component.html',
  styleUrls: ['./event-registration.component.less']
})
export class EventRegistrationComponent implements OnInit {

  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  constructor(
    private SearchEventService: SearchEventService,
    private GetPartnerIDService: GetPartnerIDService,
    private UpdateEventStatusService: UpdateEventStatusService) { }

  ngOnInit() {
    setTimeout(() => {
      $(`#partnerID`).tagsinput()
    }, 500)
    this.eventSelectionBoxRefresh()
  }

  public SubmitLoading: boolean = false
  public partnerIdIsEmpty: boolean = false
  public eventIsEmpty: boolean = false
  async register() {
    this.SubmitLoading = true
    console.log($('#partnerID').val(), $('#Event').val())
    let submit = true
    if ($('#partnerID').val() == '') {
      this.partnerIdIsEmpty = true
      submit = false
      this.SubmitLoading = false
    } else {
      this.partnerIdIsEmpty = false
      submit = true
    }
    if ($('#Event').val() == null) {
      this.eventIsEmpty = true
      submit = false
      this.SubmitLoading = false
    } else {
      this.eventIsEmpty = false
      submit = true
    }
    if (submit) {
      let profile = await this.getPartnerDetails($('#partnerID').val())
      if (profile.data != '') {
        let data = {
          "partner_id": profile.data[0].profile.partner_id,
          "title_name": profile.data[0].profile.title_name,
          "parnter_name": profile.data[0].profile.full_name,
          "email_id": profile.data[0].profile.email_id,
          "mobile_no": profile.data[0].profile.primary_mobile_no,
          "remark": "Add By BPM Team",
          "total_amount": "",
          "offering_cat_type": "19",
          "event_id": $('#Event').val().toString(),
          "off_req_id": "",
          "event_reg_flg": 1
        }

        let result = await this.UpdateEventStatusService.eventRegisterByTeam(data)

        if (result.status == "success") {
          this.Toast.fire({
            icon: 'success',
            title: 'Event Registration Successfully Done!'
          })
          this.SubmitLoading = false

        } else {
          this.Toast.fire({
            icon: 'error',
            title: 'Something went wrong!'
          })
          this.SubmitLoading = false
        }

      } else {
        this.Toast.fire({
          icon: 'warning',
          title: 'Partner id not found'
        })
        this.SubmitLoading = false
      }
    }
  }

  async getPartnerDetails(id) {
    let data = `partner_id=${id}`
    return await this.GetPartnerIDService.getPartnerID(data)
  }

  public selectEventSkeleton: boolean = true
  async eventSelectionBoxRefresh() {
    await this.getEventLists()
    let root = this
    setTimeout(function () {
      root.selectEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.event`).selectpicker('refresh');
    }, 100)
  }

  public eventList
  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

}
